/**
 * @author Bruce
 * @time 2019-07-16
 * @description 系统相关工具，比如判断浏览器环境之类的方法
 */

export default {
  /**
   * 判断当前浏览器是不是微信浏览器
   */
  isWeiXin() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  },
  /**
   * 判断安卓还是IOS客户端
   */
  judgePhone() {
    // console.log(navigator.userAgent); 
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
      return 'ios';
    } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
      return 'android';
    }
  },
  /**
   * 获取可视区域高度，监听页面窗口变化，动态修改高度
   * @param self this作用域，指向引用组件data中的pageHeight
   */
  adaptHeight(self) {
    // 获取页面可视区域高度，动态计算内容区域显示高度，监听窗口变化，动态修改显示高度
    var clientHeight = document.documentElement.clientHeight;
    self.pageHeight = clientHeight + "px";
    window.onresize = () => {
      return (() => {
        let currentHeight = document.documentElement.clientHeight;
        let diff = Math.abs(currentHeight - clientHeight);
        if (diff < 50) {
          // 解决手机底部上有虚拟操作键的情况，虚拟按键的高度一般为42px
          // 虚拟按键显示隐藏的情况下，动态修改页面，
          self.pageHeight = currentHeight + "px";
        }
      })();
    };
  },
  /**
   * 解决ios上输入框失去焦点后，页面不会回来的问题
   * 当失去焦点后，控制页面滚动到顶部
   */
  scrollPageView() {
    setTimeout(() => {
      window.scrollTo(0, document.body.scrollTop + 1);
      document.body.scrollTop >= 1 &&
        window.scrollTo(0, document.body.scrollTop - 1);
    }, 10);
  },
  /**
   * 获取url中的参数
   * @param name url中的url
   */
  getUrlKey: function (name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
  },
  /**
   * 跳转到外部签合同系统
   * @param {*} userId 
   * @param {*} companyId 
   * @param {*} themeType 
   * @param {*} noreturn 
   */
  navWeb(userId, companyId, themeType, noreturn) {
    let returnUrl = window.location.origin + window.location.pathname + "#/robbing";
    if (noreturn) {
      returnUrl = "";
    }
    window.location.href =
      "https://sign.nutrition-esthetics.com/index.html#/home" + 
      "?userId=" + userId + 
      "&companyId=" + companyId + 
      "&themeType=" + themeType + 
      "&returnUrl=" + encodeURIComponent(encodeURIComponent(returnUrl));
  },
  /**
   * 根据当前用户星级，设置当前主题类型
   * @param {Number} starLevel 用户星级 
   */
  setThemeType(starLevel, self) {
    let root = document.querySelector(":root");
    // 判断当前用户星级，四星金卡以下为黄色主题，以上为黑色主题
    if (Number(starLevel) <= 4) {
      root.style.setProperty("--color", "#fc581f");
      self.$root.themeType = "yellow";
      document.getElementById("app").classList.remove("theme-black"); // 删除黑色主题class
      document.getElementById("app").classList.add("theme-yellow"); // 添加黄色主题class
      document.documentElement.style.backgroundColor = "#fff";
    } else {
      root.style.setProperty("--color", "#facd89");
      self.$root.themeType = "black";
      document.getElementById("app").classList.remove("theme-yellow"); // 删除黄色主题class
      document.getElementById("app").classList.add("theme-black"); // 添加黑色主题class
      document.documentElement.style.backgroundColor = "#242626";
    }

    localStorage.setItem("JYDB_THEME", self.$root.themeType); // 设置长期缓存，即使退出操作也不清除此缓存
  }
}



// WEBPACK FOOTER //
// ./src/utils/sysUtils.js